export const PHONE_PATTERN = /^(?=\D*(?:\d\D*){7,}$)(?:([\d\s+()-])(?!\1{6,}))+$/
// eslint-disable-next-line
export const EMAIL_PATTERN = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i



// WEBPACK FOOTER //
// ./const/Patterns.js